import { render, staticRenderFns } from "./safesWithdrawal.vue?vue&type=template&id=4f4d5b1a"
import script from "./safesWithdrawal.vue?vue&type=script&lang=js"
export * from "./safesWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports